import { Color, Vector3, Quaternion } from "flavr-math";
import { ConnectionLineTypes, PrimitiveShape, PrimitiveMeshMaterial } from "flavr-common";
import { ConnectionRenderer } from "./connection.renderer";
const colorHelper = new Color();
const tmpVector3_1 = new Vector3();
const tmpVector3_2 = new Vector3();
const tmpVector3_3 = new Vector3();
const tmpQuaternion = new Quaternion();
const AxisY = new Vector3(0, 1, 0);
export class ArrowConnectionRenderer extends ConnectionRenderer {
    constructor(name, from, to, params) {
        super(name, from, to);
        this.params = params;
    }
    destroy() {
        super.destroy();
        this.line && this.line.destroy();
        this.cone && this.cone.destroy();
        this.line = undefined;
        this.cone = undefined;
    }
    setVisible(visible) {
        this.line && this.line.setVisible(visible);
        this.cone && this.cone.setVisible(visible);
    }
    update(params) {
        if (params.type === ConnectionLineTypes.Arrow) {
            this.params = params;
            if (this.line) {
                this.line.setColor(colorHelper.setHex(this.params.lineColor));
                this.line.setThickness(this.params.lineThickness);
                this.line.setFuzzyness(0);
            }
            if (this.cone) {
                this.cone.setColor(colorHelper.setHex(this.params.lineColor));
            }
            return true;
        }
        return false;
    }
    updateStartAndEndPoints(start, end) {
        const lineDir = tmpVector3_1.subVectors(end, start);
        const lineLength = lineDir.length();
        lineDir.multiplyScalar(1 / lineLength);
        let r = this.params.arrowHeadWidth;
        let h = this.params.arrowHeadLength;
        const offset = this.params.startOffset || 0;
        // the arrow head should not be longer than the line, so scale it down if nececary
        const maxArrowHeadLength = 0.75 * lineLength;
        if (h > maxArrowHeadLength) {
            r = (r / h) * maxArrowHeadLength;
            h = maxArrowHeadLength;
        }
        const ori = tmpQuaternion.setFromUnitVectors(AxisY, lineDir);
        const pos = tmpVector3_2.copy(start).addScaledVector(lineDir, lineLength - h / 2);
        const scale = tmpVector3_3.set(r, h, r);
        if (!this.cone) {
            this.cone = this.createCone(pos, ori, scale);
        }
        else {
            this.cone.setPosition(pos);
            this.cone.setOrientation(ori);
            this.cone.setScale(scale);
        }
        if (!this.line)
            this.line = this.createLine();
        const lineEnd = tmpVector3_2.copy(start).addScaledVector(lineDir, lineLength - h);
        start.addScaledVector(lineDir, offset);
        this.line.setStartPoint(start);
        this.line.setEndPoint(lineEnd);
    }
    createLine() {
        const batch = this.from.renderer.getLineBatch(this.from.modelUID);
        const instance = batch.createInstance();
        instance.setColor(colorHelper.setHex(this.params.lineColor));
        instance.setThickness(this.params.lineThickness);
        instance.setFuzzyness(0);
        instance.setVisible(this.from.visible && this.to.visible);
        return instance;
    }
    createCone(pos, ori, scale) {
        const instance = this.from.renderer.createInstancedPrimitiveMesh(this.from.modelUID, PrimitiveShape.Cone, PrimitiveMeshMaterial.SIMPLE_SHADING);
        instance.setPosition(pos);
        instance.setOrientation(ori);
        instance.setScale(scale);
        instance.setColor(colorHelper.setHex(this.params.lineColor));
        instance.setVisible(this.from.visible && this.to.visible);
        return instance;
    }
}
